import { GridColumnHeaderTitle } from '@mui/x-data-grid';
import { ReactNode } from 'react';

interface HeaderColDef {
  field: string;
  headerName?: string;
  computedWidth: number;
}

interface HeaderParams {
  colDef: HeaderColDef;
}

export const renderHeaderWithId =
  (idPrefix?: string, renderContent?: (colDef: HeaderColDef) => ReactNode) =>
  ({ colDef }: HeaderParams) => (
    <span id={`${idPrefix ?? ''}header-${colDef.field}`}>
      {renderContent ? (
        renderContent(colDef)
      ) : (
        <GridColumnHeaderTitle label={colDef.headerName ?? colDef.field} columnWidth={colDef.computedWidth} />
      )}
    </span>
  );
